import "@main/components/article/video";
import {Table} from "@main/components/article/table";
import {Image} from "@main/components/article/image";
import {createDomElement} from "@main/helpers/dom";

export const createArticleBlockElement = () => createDomElement({className: "article__block"});
export const createArticleBlockCaptionElement = (text) =>
    createDomElement({className: "article__block-caption", innerText: text});

document.querySelectorAll(".js-article-content").forEach((article) => {
    article
        .querySelectorAll(
            `
        :scope > table, 
        :scope > img
        `
        )
        .forEach((el) => {
            switch (el.localName) {
                case "img":
                    return new Image(el);

                case "table":
                    return new Table(el);
            }
        });
});
